// extracted by mini-css-extract-plugin
export default {"card":"KY-z","carouselContainer":"LY-z","carouselContent":"MY-z"};